//@ts-check
import axios from "axios";
import { GET_OUR_ADDRESS } from '../../app/containers/apiUrl'


export function getAppAddress() {
    return axios.get(GET_OUR_ADDRESS);
}

